import React, { useMemo } from 'react';
import { CPUIcon } from '../../common/icons/CPUIcon';

import { unixTimestampsToPrometheusRange, valueFormatter } from '../../../utils/prometheus_utils';

import usePrometheusQuery from '../../../utils/hooks/use_prometheus_query_without_range';

import StatCard from '../../common/StatCard/StatCard';
import Icon from '../../common/icons/Icon';
import COLORS from '../../../constants/colors.constants';
import { percentFormatter } from '../../../utils/formatters';
import { combineRangeAndOffset } from '../../../utils/prometheus_utils';

const getUsedCPUQuery = (rangeVector, offset) => {
  return `avg_over_time(sum(wallaroo_kube_pod_resource_usage{resource="cpu"})${combineRangeAndOffset(rangeVector, offset)})`;
}

const getRequestedCPUQuery = (rangeVector, offset) => {
  return `avg_over_time(sum(wallaroo_kube_pod_resource_requests{resource="cpu"})${combineRangeAndOffset(rangeVector, offset)})`;
}

const CPUIconComponent = () => {
  return <Icon fill={COLORS.brand} icon={CPUIcon} size={24} useTailwindSizing />
}

export const useUsedCPUQuery = ({
  startTimestamp,
  endTimestamp,
}) => {
  const query = useMemo(() => {
    const rangeObj = unixTimestampsToPrometheusRange(startTimestamp, endTimestamp);
    return getUsedCPUQuery(rangeObj.rangeVector, rangeObj.offset);
  }, [endTimestamp, startTimestamp])

  const prometheusResponse = usePrometheusQuery(query);

  return {
    chartData: prometheusResponse?.data,
    isLoading: prometheusResponse?.isLoading,
    message: prometheusResponse?.error || null,
  }
}

export const useRequestedCPUQuery = ({
  startTimestamp,
  endTimestamp,
}) => {
  const query = useMemo(() => {
    const rangeObj = unixTimestampsToPrometheusRange(startTimestamp, endTimestamp);
    return getRequestedCPUQuery(rangeObj.rangeVector, rangeObj.offset);
  }, [endTimestamp, startTimestamp])

  const prometheusResponse = usePrometheusQuery(query);

  return {
    chartData: prometheusResponse?.data,
    isLoading: prometheusResponse?.isLoading,
    message: prometheusResponse?.error || null,
  }
}

export const ContextualAVGCPUCard = ({
  startTimestamp, endTimestamp,
}) => {
  const usedResponse = useUsedCPUQuery({
    startTimestamp, endTimestamp
  })
  const usedData = usedResponse?.chartData;
  const usedValue = usedData?.length ? usedData[1] : 0;

  const requestedResponse = useRequestedCPUQuery({
    startTimestamp, endTimestamp
  })
  const requestedData = requestedResponse?.chartData;
  const requestedValue = requestedData?.length ? requestedData[1] : 0;

  const subtitle = `Used ${valueFormatter.format(usedValue)}/${valueFormatter.format(requestedValue)} CPUs Requested`;

  const content = requestedValue ? percentFormatter.format(usedValue / requestedValue) : 0;
  const isLoading = requestedResponse?.isLoading || usedResponse?.isLoading;

  return (
    <StatCard
      className=""
      icon={CPUIconComponent}
      header="Average CPU Usage Over Time"
      subtitle={subtitle}
      content={`${content}`}
      isLoading={isLoading}
    />
  )
}

export default ContextualAVGCPUCard;
